<template>
  <div>
    <vs-input label="CURP" v-model="personalProfile.curp"></vs-input>
    <vs-input label="Primer nombre" v-model="personalProfile.first_name"></vs-input>
    <vs-input label="Segundo nombre" v-model="personalProfile.second_name"></vs-input>
    <vs-input label="Apellido materno" v-model="personalProfile.last_name_1"></vs-input>
    <vs-input label="Apellido paterno" v-model="personalProfile.last_name_2"></vs-input>
    <vs-input label="País de origen" v-model="personalProfile.origin_country"></vs-input>

    <vs-button
      class="mt-2 small"
      @click="save()">Guardar</vs-button>

    <vs-button
      :disabled="!isValidForm"
      class="mt-2 ml-2 small"
      color="success"
      @click="createStpAccount()">Crear cuenta</vs-button>
  </div>
</template>

<script>
export default {
  name: "StpAccountPfForm",
  props: {
    personalProfileId: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    personalProfile: {
      curp: '',
      first_name: '',
      second_name: '',
      last_name_1: '',
      last_name_2: '',
      origin_country: '',
    },
    personalProfileState: {},
  }),
  computed: {
    isValidForm() {
      return this.isValidValue(this.personalProfileState.curp) &&
        this.isValidValue(this.personalProfileState.first_name) &&
        this.isValidValue(this.personalProfileState.last_name_1) &&
        this.isValidValue(this.personalProfileState.last_name_2) &&
        this.isValidValue(this.personalProfileState.origin_country);
    }
  },
  async mounted() {
    const {data} = await axios.get(`/api/personal-profile/${this.personalProfileId}`);
    this.personalProfile = data;
    this.setStateForm(this.personalProfile);
  },
  methods: {
    isValidValue(value) {
      return value !== '' && value !== undefined && value !== null;
    },
    async save() {
      this.$vs.loading();
      try {
        let response = await axios.put(`/api/personal-profile/${this.personalProfileId}`, {
          curp: this.personalProfile.curp,
          first_name: this.personalProfile.first_name,
          second_name: this.personalProfile.second_name,
          last_name_1: this.personalProfile.last_name_1,
          last_name_2: this.personalProfile.last_name_2,
          origin_country: this.personalProfile.origin_country
        });

        this.personalProfile = response.data;
        this.setStateForm(this.personalProfile);
      } finally {
        this.$vs.loading.close();
      }
    },
    setStateForm(personalProfile) {
      this.personalProfileState = Object.assign({}, personalProfile);
    },
    async createStpAccount() {
      await axios.post();
    }
  }
}
</script>

<style scoped>

</style>
